<template>
  <v-flex class="axa-box-general">
    <v-flex class="box-content">
      <v-flex>
        <v-row>
          <v-col class="py-0" cols="12" sm="12" md="12">
            <div class="box-subtitle mt-0">
              <h4 class="heading">Müşteri Şikayet Raporu</h4>
            </div>
            <br />
            <v-data-table :headers="headers" :items="items" :loading="loading">
              <template #top>
                <v-row>
                  <v-col cols="6"></v-col>
                  
                  <v-col cols="4">
                  <v-container>
                    <v-text-field placeholder="Ara" label="Ara">
                      <template #append-outer>
                        <v-tooltip top color="primary">
                          <template #activator="{ attrs, on }">
                            <v-btn v-bind="attrs" v-on="on" icon small @click="create = true">
                              <v-icon>mdi-plus</v-icon>
                            </v-btn>
                          </template>
                          <span>Forum Oluştur</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </v-container>
                </v-col>

   
              <v-col cols="2" 
              class="py-0 d-flex align-center justify-end"  :class="$vuetify.breakpoint.smAndDown ? '' : 'text-right'">
                <downloadExcel worksheet="Şikayet Raporu" 
                  :name="ExcelName" 
                  :fields="ExcelTableDataListFields"
                  :data="ExcelTableDataListFiltered" 
                  :before-generate="tableStartDownload"
                  :before-finish="tableFinishDownload">
                  <v-btn :disabled="ExcelTableDataListFiltered.length == 0" text class="axa-btn type-text m-p-0">
                    Excel’e Aktar
                    <axa-icon name="excel"></axa-icon>
                  </v-btn>
                </downloadExcel>
              </v-col>
               
                </v-row>
              </template>
              <template #[`item.PoliceBaslangicTarih`]="{ item }">
                {{ item.PoliceBaslangicTarih | getDate }}
              </template>
              <template #[`item.PoliceBitisTarih`]="{ item }">
                {{ item.PoliceBitisTarih | getDate }}
              </template>
              <template #[`item.TalepTarih`]="{ item }">
                {{ item.TalepTarih | getDate }}
              </template>
              <template #[`item.Tarih`]="{ item }">
                {{ item.Tarih | getDate }}
              </template>
              <template #[`item.IletimTarih`]="{ item }">
                {{ item.IletimTarih | getDate }}
              </template>
              <template #[`item.GelisTarih`]="{ item }">
                {{ item.GelisTarih | getDate }}
              </template>
              <template #[`item.CozumlenmeTarih`]="{ item }">
                {{ item.CozumlenmeTarih | getDate }}
              </template>
              <template #[`item.IptalTarih`]="{ item }">
                {{ item.IptalTarih | getDate }}
              </template>
              <template #[`item.IadeTarih`]="{ item }">
                {{ item.IadeTarih | getDate }}
              </template>
              <template #[`item.TalepTur`]="{ item }">
                {{ $options.statics.talepTurleri.find(x => x.value == item.TalepTur).text }}
              </template>
              <template #[`item.TalepEdenTur`]="{ item }">
                {{ $options.statics.talepEdenTurleri.find(x => x.value == item.TalepEdenTur).text }}
              </template>
              <template #[`item.TalepKanal`]="{ item }">
                {{ $options.statics.talepKanallari.find(x => x.value == item.TalepKanal).text }}
              </template>
              <template #[`item.TalepTip`]="{ item }">
                {{ sue_types.find(x => x.value == item.TalepTip).text }}
              </template>
              <template #[`item.TalepDetay`]="{ item }">
                {{ sue_types.find(x => x.value == item.TalepDetay).text }}
              </template>
              <template #[`item.GeriDonusKaynak`]="{ item }">
                {{ $options.statics.geriDonusKaynaklari.find(x => x.value == item.GeriDonusKaynak).text }}
              </template>
              <template #[`item.TalepSonuc`]="{ item }">
                {{
                  $options.statics.talepSonuclari.find(x => x.value == item.TalepSonuc)
                    ? $options.statics.talepSonuclari.find(x => x.value == item.TalepSonuc).text
                    : ''
                }}
              </template>
              <template #[`item.actions`]="{ item }">
                <v-icon small @click="editItem(item)">mdi-pencil</v-icon>
                <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <v-dialog v-if="create" v-model="create">
          <create @close="init"></create>
        </v-dialog>
        <v-dialog v-if="edit" v-model="edit">
          <edit @close="init" :item="selectedObject" type="edit"></edit>
        </v-dialog>
        <v-dialog v-if="deleteModal" v-model="deleteModal" width="600px">
          <v-card>
            <v-card-title>{{ selectedObject.ID }} nolu talebi silmek üzeresiniz!</v-card-title>
            <v-card-text>{{ selectedObject.ID }} nolu talebi silmek istediğinize emin misiniz?</v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                :block="$vuetify.breakpoint.smAndDown"
                class="ma-2 axa-btn type-outline"
                @click="deleteModal = false"
              >
                Vazgeç
              </v-btn>
              <v-btn
                :block="$vuetify.breakpoint.smAndDown"
                class="ma-2 axa-btn type-dark big-60"
                @click="deleteHandle()"
              >
                Sil
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-flex>
  </v-flex>
</template>
<script>
import { eventBus } from '../../main';
import statics from '../../core/utils/statics/customerComplaint.static';
import moment from 'moment';
import JsonExcel from 'vue-json-excel';
import { Helpers } from '@/mixins/helpers';
export default {
  statics,
  components: {
    Create: () => import('../Modals/ModalCreateCustomerComplaintReport.vue'),
    Edit: () => import('../Modals/ModalCreateCustomerComplaintReport.vue'),
     downloadExcel: JsonExcel,
  },
  data() {
    return {
      create: false,
      edit: false,
      deleteModal: false,
      selectedObject: null,
      headers: [
        { text: 'Talep Numarası', value: 'ID' },
        { text: 'ACENTE ADI', value: 'AcenteAdi' },
        { text: 'ACENTE PARTAJI', value: 'AcenteNo' },
        { text: 'Talep Türü', value: 'TalepTur' },
        { text: 'Talep Eden TCKN/Vergi Numarası', value: 'TCVK' },
        { text: 'Talep Eden Ad/Unvanı', value: 'AdUnvan1' },
        { text: 'Talep Eden Soyadı', value: 'AdUnvan3' },
        { text: 'Talebe İlişkin Poliçe Numarası', value: 'PoliceNo' },
        { text: 'Poliçe Başlangıç Tarihi', value: 'PoliceBaslangicTarih' },
        { text: 'Poliçe Bitiş Tarihi', value: 'PoliceBitisTarih' },
        { text: 'Ürün Adı', value: 'TarifeAdi' },
        { text: 'Ürün Türü', value: 'TarifeKod' },
        { text: 'BRANŞ', value: 'BransKod' },
        { text: 'Hasar Dosya No', value: 'HasarDosyaNo' },
        { text: 'Talep Eden Türü', value: 'TalepEdenTur' },
        { text: 'Talep Kanalı', value: 'TalepKanal' },
        { text: 'Talep Tarihi', value: 'TalepTarih' },
        { text: 'Oluşturma Tarihi', value: 'Tarih' },
        { text: 'İlgili Birime İletim Tarihi', value: 'IletimTarih' },
        { text: 'İlgili Birimden Geliş Tarihi', value: 'GelisTarih' },
        { text: 'Çözümlenme Tarihi', value: 'CozumlenmeTarih' },
        { text: 'Çözüm süresi (Gün)', value: 'CozumSure' },
        { text: 'Talep Tipi', value: 'TalepTip' },
        { text: 'Talep Detay', value: 'TalepDetay' },
        { text: 'Talep Sonucu', value: 'TalepSonuc' },
        { text: 'Talep Sonucuna İlişkin Detay_Alınan Aksiyon', value: 'DetayAksiyon' },
        { text: 'Geri Dönüş Kaynağı', value: 'GeriDonusKaynak' },
        { text: 'İptal Tarihi', value: 'IptalTarih' },
        { text: 'Tahsilat Tutarı', value: 'TahsilatTutar' },
        { text: 'İade Tarihi', value: 'IadeTarih' },
        { text: 'İade Tutarı', value: 'IadeTutar' },
        { text: '', value: 'actions' },
      ],
      items: [],
      sue_types: [],
      loading: true,
      ExcelName: null,
      ExcelTableDataListFiltered: [],
      ExcelTableDataList: [],
      tableItemsPerPageDefault: 20,
      tableItemsPerPage: 20,
    };
  },
  computed: {
     ExcelTableDataListFields() {
      return {
        'ID':'ID',
        'AcenteAdi': 'AcenteAdi',
            'TalepTur': 'TalepTur',
            'TCVK': 'TCVK',
            'AdUnvan1': 'AdUnvan1',
            'AdUnvan2': 'AdUnvan2',
            'AdUnvan3': 'AdUnvan3',
            'PoliceNo': 'PoliceNo',
            'Police Baslangic Tarihi': {
                field: 'PoliceBaslangicTarih',
                callback: value => {
                  return Helpers.filters.momentDate(value);
                },
              },
            'Police Bitis Tarih': {
                field: 'PoliceBitisTarih',
                callback: value => {
                  return Helpers.filters.momentDate(value)
                },
              },
            'TarifeKod': 'TarifeKod',
            'TarifeAdi': 'TarifeAdi',
            'BransKod': 'BransKod',
            'HasarDosyaNo': 'HasarDosyaNo',
            'TalepEdenTur': 'TalepEdenTur',
            'TalepKanal': 'TalepKanal',
            'Talep Tarihi': {
                field: 'TalepTarih',
                callback: value => {
                  return Helpers.filters.momentDate(value)
                },
              },
                'Tarih': {
                field: 'Tarih',
                callback: value => {
                  return Helpers.filters.momentDate(value)
                },
              },
             'Iletim Tarih': {
                field: 'IletimTarih',
                callback: value => {
                  return Helpers.filters.momentDate(value)
                },
              },
              'Gelis Tarih': {
                field: 'GelisTarih',
                callback: value => {
                  return Helpers.filters.momentDate(value)
                },
              },
              'Cozumlenme Tarih': {
                field: 'CozumlenmeTarih',
                callback: value => {
                  return Helpers.filters.momentDate(value)
                },
              },
            'CozumSure': 'CozumSure',
            'TalepTip': 'TalepTip',
            'TalepDetay': 'TalepDetay',
            'TalepSonuc': 'TalepSonuc',
            'DetayAksiyon': 'DetayAksiyon',
            'GeriDonusKaynak': 'GeriDonusKaynak',
            'IptalTarih': 'IptalTarih',
            'TahsilatTutar': 'TahsilatTutar',
            'IadeTarih': 'IadeTarih',
            'IadeTutar': 'IadeTutar',
            'OPID': 'OPID'
      };
    }
  },
  async created() {
    const [sue_types, datas] = await Promise.all([
      this.$store.dispatch('getSueTypeDetails'),
      this.$store.dispatch('getCustomerComplaintReport', {}),
    ]);
    this.items = datas.data;
    this.sue_types = this.$store.getters.GetSueTypeDetails.map(x => ({
      value: x.Kod,
      text: x.Ad,
      parent_value: x.ParentID,
    }));
    this.loading = false;
    this.ExcelTableDataListFiltered=this.items;
  },
  methods: {
    async init(val) {
      if (val) {
        var datas = await this.$store.dispatch('getCustomerComplaintReport', {});
        this.items = datas.data;
        this.create = !val;
        this.edit = !val;
        this.deleteModal = !val;
      }
    },
    async deleteItem(val) {
      this.selectedObject = val;
      this.deleteModal = true;
    },
    async deleteHandle() {
      var ret = await this.$store.dispatch('deleteCustomerComplaintReport', this.selectedObject);
      if(ret.data.Basarili) {
        eventBus.$emit('InfoSnackbar', {
          statePath: {
            Mesajlar: [
              {
                Kod: '1',
                Mesaj: ret.data.Mesajlar.Bilgiler[0],
                Tip: 'Bilgi',
                Yer: '',
              },
            ],
          },
        });
        this.init(true)
      }
      else
        eventBus.$emit('InfoSnackbar', {
          statePath: {
            Mesajlar: [
              {
                Kod: '1',
                Mesaj: ret.data.Mesajlar.Hatalar[0],
                Tip: 'Hata',
                Yer: '',
              },
            ],
          },
        });
    },
    async editItem(val) {
      this.selectedObject = val;
      this.edit = true;
    },
 
    //  getFilteredTableList(e) {
    //   this.ExcelTableDataListFiltered = [];
    //   this.ExcelTableDataListFiltered = e;
    // },
    tableStartDownload() {
      this.tableItemsPerPage = 1000;
      this.ExcelName = 'Şikayet Raporu-' + moment().locale('tr').format('DD-MM-YYYY_hh-mm-ss') + '.xls';
    },
    tableFinishDownload() {
      this.tableItemsPerPage = this.tableItemsPerPageDefault;
    },
  },
  filters: {
    getDate(val) {
      const date = new Date(val);
      return `${date.getDate() < 10 ? '0' + date.getDate() : date.getDate()}.${
        date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
      }.${date.getFullYear()}`;
    },
  },
};
</script>
<style lang="">
</style>